import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';
import { SettingsGeneralDpoService } from '@features/settings/general/dpo/shared/settings-general-dpo.service';

@Injectable()
export class SettingsDefaultGuardService implements CanLoad, CanActivate {
    constructor(
        private authTokenService: AuthTokenService,
        private dpoService: SettingsGeneralDpoService,
        private router: Router,
    ) { }

    public canActivate(): Observable<boolean> {
        return this.canLoad();
    }

    public canLoad(): Observable<boolean> {
        return this.dpoService.getShow()
            .pipe(
                map((show: boolean) => {
                    if (show) { return show; }

                    return this.restrictedUser();
                }),
            );
    }

    private restrictedUser(): boolean {
        // tslint:disable:no-bitwise
        const isUser: boolean = !!(this.authTokenService.role & RoleTypes.User);
        const isPartnerRestrict: boolean = !!(this.authTokenService.role & RoleTypes.PartnerRestrict);

        if (isUser || isPartnerRestrict) {
            this.router.navigate(['settings/my-settings']);

            return false;
        }

        return true;
    }
}
